<template>
        <v-dialog width="fit-content" v-model="dialog">
            <template v-slot:activator="{ on }">
                <span v-on="on">
                    <slot></slot>
                </span>
            </template>

            <v-card>
                <v-card-title>
                    <span class="headline">Edit Driver</span>
                    <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-tabs
                            v-model="tab_edit_restaurant"
                            background-color="grey lighten-4"
                            fixed-tabs
                            slider-color="grey darken-1"
                            style="margin-bottom:16px"
                        >
                            <v-tab>Main</v-tab>
                            <v-tab>Documents</v-tab>
                            <v-tab>Activity</v-tab>
                        </v-tabs>

                        <v-form ref="form">
                          <v-tabs-items v-model="tab_edit_restaurant">
                          <!-- tab 1 -->
                          <v-tab-item>
                            <v-row>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="First Name*"
                                            hint="enter first name"
                                            required
                                            v-model="firstName"
                                            :error-messages="firstNameErrors"
                                            @input="$v.firstName.$touch()"
                                            @blur="$v.firstName.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Last Name"
                                            hint="enter a last name"
                                            v-model="lastName"
                                            :error-messages="lastNameErrors"
                                            required
                                            @input="$v.lastName.$touch()"
                                            @blur="$v.lastName.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Driver Email*"
                                            required
                                            v-model="email"
                                            :error-messages="emailErrors"
                                            @input="$v.email.$touch()"
                                            @blur="$v.email.$touch()"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-menu
                                        v-model="date_of_birth_picker"
                                        transition="scale-transition"
                                        :close-on-content-click="false"
                                        :nudge-width="200"
                                        max-width="346px"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-on="on"
                                                clear-icon="mdi-close"
                                                prepend-icon="mdi-calendar"
                                                clearable
                                                outlined
                                                label="Date of birth"
                                                hint="22/11/1990"
                                                v-model="date_of_birth"
                                                :error-messages="dateOfBirthErrors"
                                                @input="$v.date_of_birth.$touch()"
                                                @blur="$v.date_of_birth.$touch()"
                                                autocomplete="off"
                                            ></v-text-field>
                                        </template>

                                        <v-card max-width="346px">
                                        <v-date-picker
                                            v-model="date_of_birth_selected"
                                            scrollable
                                            actions
                                            full-width
                                            first-day-of-week="1"
                                            :title-date-format="getDateOfBirthText"
                                            v-on:click:date="dateOfBirthSelect"
                                        ></v-date-picker>
                                        </v-card>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Address_1"
                                            v-model="address_1"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Address_2"
                                            v-model="address_2"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="City"
                                            hint="Enter city"
                                            v-model="city"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Postcode"
                                            hint="Enter postcode"
                                            v-model="postcode"
                                    ></v-text-field>
                                </v-col>


                                <v-col cols="6" sm="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Telephone Number"
                                            type="Telephone"
                                            v-model="phone"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Emergency contact name"
                                            v-model="emergency_contact_name"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Emergency contact phone"
                                            v-model="emergency_contact_phone"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Car Make"
                                            v-model="car_make"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Car Model"
                                            v-model="car_model"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Car Registration"
                                            v-model="car_registration"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Car Insurer"
                                            v-model="car_insurer"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-menu
                                        v-model="car_insurance_renewal_date_picker"
                                        transition="scale-transition"
                                        :close-on-content-click="false"
                                        :nudge-width="200"
                                        max-width="346px"
                                        offset-y
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                            v-on="on"
                                            clear-icon="mdi-close"
                                            prepend-icon="mdi-calendar"
                                            clearable
                                            outlined
                                            label="Car Insurance Renewal Date"
                                            hint="22/11/2019"
                                            persistent-hint
                                            v-model="car_insurance_renewal_date"
                                            :error-messages="carInsuranceRenewalDateErrors"
                                            @input="$v.car_insurance_renewal_date.$touch()"
                                            @blur="$v.car_insurance_renewal_date.$touch()"
                                            autocomplete="off"
                                        ></v-text-field>
                                        </template>

                                        <v-card max-width="346px">
                                        <v-date-picker
                                            v-model="car_insurance_renewal_date_selected"
                                            scrollable
                                            actions
                                            full-width
                                            first-day-of-week="1"
                                            :title-date-format="getCarInsuranceRenewalDateText"
                                            v-on:click:date="carInsuranceRenewalDateSelect"
                                        ></v-date-picker>
                                        </v-card>
                                    </v-menu>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-switch v-model="have_experience" :false-value="EXPERIANCE_NO" :true-value="EXPERIANCE_YES" :label="`Have experience`"></v-switch>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Experience description"
                                            v-model="experience_description"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Bank Name of Account Holder"
                                            v-model="bank_name_of_account_holder"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Bank sort code"
                                            v-model="bank_sort_code"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6" md="6">
                                    <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Bank account number"
                                            v-model="bank_account_number"
                                            persistent-hint
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="12" class="area-select">
                                    <v-select
                                            outlined
                                            label="Areas Assigned to*"
                                            multiple
                                            chips
                                            deletable-chips
                                            hint="leave blank not to assign driver to any areas"
                                            persistent-hint
                                            v-model="area_ids"
                                            :items="areasList"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="selectAreaErrors"
                                            @change="onChangeArea"
                                            @blur="$v.area_ids.$touch()"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" class="drivers_resturants-select">
                                    <v-select
                                            outlined
                                            label="Area's Restaurants Not Assigned to Driver"
                                            multiple
                                            chips
                                            deletable-chips
                                            hint="if leave blank driver to be assigned to all Area's restaurants"
                                            persistent-hint
                                            v-model="restaurant_ids"
                                            :items="restaurantsList"
                                            item-text="name"
                                            item-value="id"
                                            :disabled="area_ids.length == 0"
                                            :error-messages="selectRestaurantErrors"
                                            @change="onChangeRestaurant"
                                            @blur="$v.restaurant_ids.$touch()"
                                    ></v-select>
                                </v-col>
                                <!-- Readonly text -->
                                <v-col cols="12" md="3" class="py-0">
                                    <v-text-field
                                    label="Hear About Us"
                                    :value="hear_about_us ? hear_about_us.name : 'No referral data'"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                    />
                                </v-col>
                                <!-- Type dropdown -->
                                <v-col cols="12" md="2" class="py-0">
                                    <v-text-field v-if="hear_about_us && hear_about_us.paid === 1" label="Type" :value="hear_about_us.type" readonly outlined dense hide-details />
                                    <v-select
                                    v-else
                                    v-model="hearAboutUsType"
                                    :items="['restaurant', 'driver']"
                                    label="Select Type"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="hear_about_us && hear_about_us.paid === 1"
                                    />
                                </v-col>
                                <!-- Source dropdown -->
                                <v-col cols="12" md="2" class="py-0">
                                    <v-autocomplete
                                    v-model="hearAboutUsValue"
                                    :items="hearAboutUsOptions"
                                    item-text="name"
                                    item-value="id"
                                    :label="hearAboutUsType ? 'Select ' + hearAboutUsType : 'Select Source'"
                                    outlined
                                    dense
                                    hide-details
                                    :disabled="!hearAboutUsType || (hear_about_us && hear_about_us.paid === 1)"
                                    clearable
                                    />
                                </v-col>
                                <!-- Status (Paid / Not Paid) -->
                                <v-col cols="12" md="1" class="py-0">
                                    <v-chip
                                    :color="hear_about_us && hear_about_us.paid ? 'green' : 'red'"
                                    dark
                                    class="ma-2"
                                    >
                                    {{ hear_about_us && hear_about_us.paid ? 'Paid' : 'Not Paid' }}
                                    </v-chip>
                                </v-col>

                                <!-- Buttons -->
                                <v-col cols="12" md="4" class="py-0 d-flex align-center justify-end">
                                    <!-- Update -->
                                    <v-btn
                                    color="primary"
                                    height="40"
                                    class="ma-0 mr-2"
                                    :disabled="!hearAboutUsType || !hearAboutUsValue || (hear_about_us && hear_about_us.paid === 1)"
                                    @click="updateHearAboutUs"
                                    >
                                    Update
                                    </v-btn>
                                    <!-- Mark as Paid (only if not paid) -->
                                    <v-btn
                                    v-if="hear_about_us && hear_about_us.paid === 0"
                                    color="success"
                                    height="40"
                                    class="ma-0"
                                    @click="markAsPaid"
                                    >
                                    Mark as Paid
                                    </v-btn>
                                </v-col>
                                <v-row class="align-center mt-2">
                                    <!-- Warning textarea -->
                                    <v-col cols="8">
                                        <v-textarea
                                        v-model="newWarning"
                                        label="Add Warning"
                                        outlined
                                        rows="2"
                                        auto-grow
                                        hide-details
                                        />
                                    </v-col>

                                    <!-- Submit button -->
                                    <v-col cols="4" class="d-flex align-center">
                                        <v-btn
                                        color="red"
                                        dark
                                        @click="submitWarning"
                                        >
                                        Add Warning
                                        </v-btn>
                                    </v-col>
                                </v-row>


                                <v-col cols="12" md="12" class="py-0 mt-4">
                                    <v-text-field
                                    label="Goal"
                                    :value="goal ? goal : 'No data'"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                    />
                                </v-col>

                                <v-col cols="12" sm="12">
                                    <v-switch v-model="switch_change_password" :label="`Change Password`"></v-switch>
                                </v-col>

                                <v-col cols="12" sm="12" v-if="switch_change_password">
                                    <v-text-field
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            @click:append="showPassword = !showPassword"
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            name="password"
                                            label="Password"
                                            v-model="password"
                                            :rules="passwordRules"
                                            :counter="12"
                                    ></v-text-field>
                                </v-col>

                            </v-row>
                          </v-tab-item>
                          <!--/ tab 1 -->
                          <!-- tab 2 -->
                          <v-tab-item>
                            <v-row style="align-items: start;">
                                <v-col cols="12" sm="6" md="3">
                                    <b>License Front Photo</b>
                                    <hr>
                                    <input
                                        type="file"
                                        style="display: none"
                                        name="driver_license_front_photo"
                                        ref="driver_license_front_photo"
                                        id="driver_license_front_photo"
                                        accept="image/*"
                                        @change="onChangDriverLicenseFrontPhoto"
                                    />
                                    <v-btn color="primary" @click="onAddDriverLicenseFrontPhoto" text small>
                                        <v-icon left>mdi-attachment</v-icon>Choose License Front Photo
                                    </v-btn>

                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" v-if="driver_license_front_photo">
                                            <a :href="getPhotoPath(driver_license_front_photo)" target="_blank"><v-img :src="getPhotoPath(driver_license_front_photo)"></v-img></a>
                                            <v-btn v-if="driver_license_front_photo" color="error" text @click="onRemoveDriverLicenseFrontPhoto()">
                                                <v-icon left>mdi-close</v-icon>Remove Photo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <b>License Back Photo</b>
                                    <hr>
                                    <input
                                        type="file"
                                        style="display: none"
                                        name="driver_license_back_photo"
                                        ref="driver_license_back_photo"
                                        id="driver_license_back_photo"
                                        accept="image/*"
                                        @change="onChangDriverLicenseBackPhoto"
                                    />
                                    <v-btn color="primary" @click="onAddDriverLicenseBackPhoto" text small>
                                        <v-icon left>mdi-attachment</v-icon>Choose License Back Photo
                                    </v-btn>

                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" v-if="driver_license_back_photo">
                                            <a :href="getPhotoPath(driver_license_back_photo)" target="_blank"><v-img :src="getPhotoPath(driver_license_back_photo)"></v-img></a>
                                            <v-btn v-if="driver_license_back_photo" color="error" text @click="onRemoveDriverLicenseBackPhoto()">
                                                <v-icon left>mdi-close</v-icon>Remove Photo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <b>Identity Photo</b>
                                    <hr>
                                    <input
                                        type="file"
                                        style="display: none"
                                        name="identity_photo"
                                        ref="identity_photo"
                                        id="identity_photo"
                                        accept="image/*"
                                        @change="onChangIdentityPhoto"
                                    />
                                    <v-btn color="primary" right @click="onAddIdentityPhoto" text small>
                                        <v-icon left>mdi-attachment</v-icon>Choose Identity Photo
                                    </v-btn>

                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" v-if="identity_photo">
                                            <a :href="getPhotoPath(identity_photo)" target="_blank"><v-img :src="getPhotoPath(identity_photo)"></v-img></a>
                                            <v-btn v-if="identity_photo" color="error" text @click="onRemoveIdentityPhoto()">
                                                <v-icon left>mdi-close</v-icon>Remove Photo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <b>Profile Photo</b>
                                    <hr>
                                    <input
                                        type="file"
                                        style="display: none"
                                        name="photo_src"
                                        ref="photo_src"
                                        id="photo_src"
                                        accept="image/*"
                                        @change="onChangPhotoSrc"
                                    />
                                    <v-btn color="primary" right @click="onAddPhotoSrc" text small>
                                        <v-icon left>mdi-attachment</v-icon>Choose Profile Photo
                                    </v-btn>

                                    <v-row>
                                        <v-col cols="12" sm="12" md="12" v-if="photo_src">
                                            <a :href="getPhotoPath(photo_src)" target="_blank"><v-img :src="getPhotoPath(photo_src)"></v-img></a>
                                            <v-btn v-if="photo_src" color="error" text @click="onRemovePhotoSrc()">
                                                <v-icon left>mdi-close</v-icon>Remove Photo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-banner single-line>
                                        <b>Right to work photos</b>
                                        <template v-slot:actions>
                                            <input
                                                type="file"
                                                style="display: none"
                                                name="right_to_work_photo"
                                                ref="right_to_work_photo"
                                                id="right_to_work_photo"
                                                accept="image/*"
                                                @change="onChangRightToWorkPhoto"
                                                multiple
                                            />
                                            <v-btn color="primary" right @click="onAddRightToWorkPhotos" text small>
                                                <v-icon left>mdi-plus</v-icon>Add Right To Work Photos
                                            </v-btn>
                                        </template>
                                    </v-banner>

                                    <v-row>
                                        <v-col cols="12" sm="6" md="3" v-for="(item, index) of right_to_work_photos" :key="item.id">
                                            <a :href="getPhotoPath(item.file_name)" target="_blank"><v-img :src="getPhotoPath(item.file_name)"></v-img></a>
                                            <v-btn v-if="item.file_name" color="error" text @click="onRemoveRightToWorkPhoto(index)">
                                                <v-icon left>mdi-close</v-icon>Remove Photo
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                           <!-- Driver Service Agreement Display -->
                            <v-row>
                                <v-col cols="6" sm="6">
                                    <v-banner single-line>
                                        <b>Driver Service Agreement</b>
                                    </v-banner>

                                    <div v-if="service_agreement_src">
                                        <a :href="getServiceAgreementPath(service_agreement_src)" target="_blank">
                                            <v-icon left>mdi-file-pdf-box</v-icon>Download Service Agreement
                                        </a>
                                    </div>
                                    <div v-else>
                                        <span>No Service Agreement uploaded yet.</span>
                                    </div>
                                </v-col>
                                <v-col cols="6" sm="6">
                                    <v-banner single-line>
                                        <b>Alcohol Delivery Certificate</b>
                                    </v-banner>

                                    <div v-if="alcohol_delivery_certificate">
                                        <a :href="getAlcoholDeliveryCertificatePath(alcohol_delivery_certificate)" target="_blank">
                                            <v-icon left>mdi-file-pdf-box</v-icon>Download Alcohol Delivery Certificate
                                        </a>
                                    </div>
                                    <div v-else>
                                        <span>No Alcohol Delivery Certificate uploaded yet.</span>
                                    </div>
                                </v-col>
                            </v-row>
                          </v-tab-item>
                          <!-- tab 3 -->
                          <v-tab-item>
                                <v-card flat style="min-height: 450px; width: 600px;">
                                    <v-card-title>
                                    <span class="text-h6">
                                        Warnings
                                        <v-chip color="red" dark small class="ml-2">
                                        {{ warning ? warning.length : 0 }}
                                        </v-chip>
                                    </span>
                                    </v-card-title>
                                    <v-card-text>
                                       <v-textarea :value="(warning && warning.length) ? warning.map(w => `• ${w.comment}` + (w.moderator ? ' - by ' + w.moderator.first_name + ' ' + w.moderator.last_name : '') +` on ${new Date(w.created_at).toLocaleDateString('en-GB')}`).join('\n') : 'No warnings yet'" outlined dense auto-grow readonly hide-details></v-textarea>
                                    </v-card-text>
                                </v-card>
                          </v-tab-item>
                          <!--/ tab 2 -->
                          </v-tabs-items>
                            <div class="d-flex justify-center">
                                <v-btn
                                        depressed
                                        class="mr-4 primary"
                                        :disabled="this.$v.$invalid || localLoading"
                                        @click="submit"
                                        :loading="localLoading"
                                >
                                    <v-icon left>mdi-check-box-outline</v-icon>
                                    Accept Changes
                                </v-btn>
                                <v-btn
                                        class="warning"
                                        depressed
                                        @click="cancel"
                                        :loading="localLoading"
                                >
                                    <v-icon left>mdi-cancel</v-icon>
                                    Cancel
                                </v-btn>
                            </div>

                        </v-form>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, /* maxLength,*/ email, /*numeric*/} from 'vuelidate/lib/validators'
    import {mapGetters} from 'vuex'
    import * as _ from 'lodash'
    import moment from 'moment';
    import CompressImage from "@/utils/compress-image";
    import {STATUS_RESTAURANT_ACTIVE} from "../../store/areas";

    const image_supported_types = [
        "image/png", "image/jpeg"
    ];
    const image_regex = /(.*?)\.(jpg|jpeg|png)$/;

    const EXPERIANCE_YES = 10;
    const EXPERIANCE_NO = 20;
    const DRIVER_STATUS_ACTIVE = 10;

    export default {
        mixins: [validationMixin],
        name: "NewLocationModal",
        props: ['thisDriverData'],
        validations: {
            firstName: {required, /* maxLength: maxLength(10)*/},
            email: {required, email},
            // phone: {required, /*numeric*/},
            lastName: {},
            date_of_birth: {  },
            car_insurance_renewal_date: { },
            // area: {required},
            // address_1: { required },
            // address_2: { required }
            // emergency_contact_name: { },
            // emergency_contact_phone: { },
            // bank_sort_code: { },
            // bank_account_number: { },
            area_ids: {},
            restaurant_ids: {}
        },
        data: () => ({
            switch_change_password: false,
            showPassword: false,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => (v && v.length >= 6) || 'Password should be at least six symbols long'
            ],
            /*valid: false,*/
            driverData: null,
            readOnly: false,
            localLoading: false,
            service_agreement_src: null,
            alcohol_delivery_certificate:null,
            hear_about_us:'',
            hearAboutUsType: '',
            warning:'',
            newWarning: "",
            hearAboutUsValue: null,
            dialog: false,
            firstName: '',
            lastName: '',
            email: '',
            date_of_birth: '',
            car_make: '',
            car_model: '',
            car_registration: '',
            car_insurance_renewal_date: '',
            car_insurer: '',
            have_experience: '',
            experience_description: '',
            address_1: '',
            address_2: '',
            emergency_contact_name: '',
            emergency_contact_phone: '',
            bank_name_of_account_holder: '',
            bank_sort_code: '',
            bank_account_number: '',
            goal:'',
            phone: '',
            city: '',
            postcode: '',
            password: '',
            //--
            driver_license_front_photo: void 0,
            driver_license_back_photo: void 0,
            identity_photo: void 0,
            photo_src: void 0,
            // --
            new_right_to_work_photos_uid_iterator: -1,
            right_to_work_photos: [],
            area_ids: [],
            restaurant_ids: [],
            // --
            tab_edit_restaurant: void 0,
            date_of_birth_selected: void 0,
            date_of_birth_picker: false,
            car_insurance_renewal_date_selected: void 0,
            car_insurance_renewal_date_picker: false,
            EXPERIANCE_YES,
            EXPERIANCE_NO,
            driver_license_front_src_photo: void 0,
            driver_license_back_src_photo: void 0,
            identity_src_photo: void 0,
            image_data: void 0,
            imgRules: [
                value => {
                    if (value && value.size > 10000000) {
                        return 'File size should be less than 10 MB!';
                    }
                    return true;
                }
            ],
            response_errors: [],
        }),
        watch: {
            date_of_birth: function(date_of_birth_new, old) {
                if (old != date_of_birth_new && /\d\d\/\d\d\/\d\d\d\d/.test(date_of_birth_new)) { // check is date valid format
                    this.$data.date_of_birth_selected = moment(date_of_birth_new, "DD/MM/YYYY").format('YYYY-MM-DD');
                }
            },
            car_insurance_renewal_date: function(car_insurance_renewal_date_new, old) {
                if (old != car_insurance_renewal_date_new && /\d\d\/\d\d\/\d\d\d\d/.test(car_insurance_renewal_date_new)) { // check is date valid format
                    this.$data.car_insurance_renewal_date_selected = moment(car_insurance_renewal_date_new, "DD/MM/YYYY").format('YYYY-MM-DD');
                }
            },
        },
        computed: {
            ...mapGetters([
                'areas',
                'restaurants',
                'allDrivers'
            ]),
            activeDrivers() {
                return this.allDrivers.filter(driver => driver.status === DRIVER_STATUS_ACTIVE);
            },
            hearAboutUsOptions() {
                if (this.hearAboutUsType === 'restaurant') {
                    return this.restaurants.map(r => ({
                        id: r.id,
                        name: r.name,
                    }));
                }

                if (this.hearAboutUsType === 'driver') {
                    return this.activeDrivers.map(d => ({
                        id: d.id,
                        name: `${d.first_name} ${d.last_name || ''}`.trim(),
                    }));
                }
                return [];
            },
            isPaid() {
                return this.hear_about_us && this.hear_about_us.paid === 1;
            },
            imagesBaseUrl() {
                return this.appConfig.app_url + '/images';
            },
            selectAreaErrors () {
                const errors = [];
                if (!this.$v.area_ids.$dirty) {
                    return errors;
                }
                // !this.$v.area_ids.required && errors.push('Area is required');
                return errors
            },
            selectRestaurantErrors () {
                const errors = [];
                if (!this.$v.restaurant_ids.$dirty) {
                    return errors;
                }
                // !this.$v.restaurant_ids.required && errors.push('Resturants is required');
                return errors
            },
            firstNameErrors () {
                const errors = []
                if (!this.$v.firstName.$dirty) return errors
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.firstName.required && errors.push('First name is required.')
                return errors
            },
            lastNameErrors () {
                const errors = []
                if (!this.$v.lastName.$dirty) return errors
                // !this.$v.lastName.required && errors.push('Last Name is required.')
                return errors
            },
            emailErrors () {
                const errors = []
                if (!this.$v.email.$dirty) return errors
                !this.$v.email.email && errors.push('Must be valid e-mail')
                !this.$v.email.required && errors.push('E-mail is required')

                // response errors
                let resp_errors = _.get(this.response_errors, 'email', []);
                _.each(resp_errors, p => errors.push(p));

                return errors
            },
            dateOfBirthErrors () {
                const errors = [];
                if (!this.$v.date_of_birth.$dirty) {
                    return errors;
                }
                // !this.$v.date_of_birth.required && errors.push('Date is required.')
                this.$data.date_of_birth && !moment(this.$data.date_of_birth, "DD/MM/YYYY").isValid() && errors.push('Date invalid format.')
                return errors
            },
            carInsuranceRenewalDateErrors () {
                const errors = [];
                if (!this.$v.car_insurance_renewal_date.$dirty) {
                    return errors;
                }
                // !this.$v.car_insurance_renewal_date.required && errors.push('Date is required.')
                this.$data.car_insurance_renewal_date && !moment(this.$data.car_insurance_renewal_date, "DD/MM/YYYY").isValid() && errors.push('Date invalid format.')
                return errors
            },
            areasList() {
                return this.areas;
            },
            restaurantsList() {
                if (this.area_ids.length == 0) {
                    return [];
                }

                return _.filter(this.restaurants, p => this.area_ids.indexOf(+p.area_id) !== -1 && p.status == STATUS_RESTAURANT_ACTIVE);
            },
        },
        created(){
            // --
        },
        mounted()
        {
            this.driverData = this.thisDriverData;
            this.id = this.thisDriverData.id;
            this.firstName = this.thisDriverData.first_name;
            this.lastName = this.thisDriverData.last_name;
            this.email = this.thisDriverData.email;
            if (moment(this.thisDriverData.date_of_birth, "YYYY-MM-DD").isValid()) {
                this.date_of_birth = moment(this.thisDriverData.date_of_birth, "YYYY-MM-DD").format('DD/MM/YYYY');
            }
            this.car_make = this.thisDriverData.car_make;
            this.car_model = this.thisDriverData.car_model;
            this.car_registration = this.thisDriverData.car_registration;
            if (moment(this.thisDriverData.car_insurance_renewal_date, "YYYY-MM-DD").isValid()) {
                this.car_insurance_renewal_date = moment(this.thisDriverData.car_insurance_renewal_date, "YYYY-MM-DD").format('DD/MM/YYYY');
            }
            this.car_insurer = this.thisDriverData.car_insurer;
            this.have_experience = this.thisDriverData.have_experience;
            this.experience_description = this.thisDriverData.experience_description;
            this.address_1 = this.thisDriverData.address_1;
            this.address_2 = this.thisDriverData.address_2;
            this.emergency_contact_name = this.thisDriverData.emergency_contact_name;
            this.emergency_contact_phone = this.thisDriverData.emergency_contact_phone;
            this.bank_name_of_account_holder = this.thisDriverData.bank_name_of_account_holder;
            this.bank_sort_code = this.thisDriverData.bank_sort_code;
            this.bank_account_number = this.thisDriverData.bank_account_number;
            this.phone = this.thisDriverData.phone;
            this.city = this.thisDriverData.city;
            this.postcode = this.thisDriverData.postcode;
            this.status = this.thisDriverData.status;
            //
            this.area_ids = _.map(this.thisDriverData.area_ids, p => +p.area_id);
            this.restaurant_ids = _.map(this.thisDriverData.restaurant_ids, p => +p.restaurant_id);
            //
            this.driver_license_front_photo = this.thisDriverData.driver_license_front_photo;
            this.driver_license_back_photo = this.thisDriverData.driver_license_back_photo;
            this.identity_photo = this.thisDriverData.identity_photo;
            this.photo_src = this.thisDriverData.photo_src;
            this.right_to_work_photos = this.thisDriverData.right_to_work_photos;
            this.service_agreement_src=this.thisDriverData.service_agreement_src;
            this.alcohol_delivery_certificate=this.thisDriverData.alcohol_delivery_certificate;
            this.hear_about_us = this.thisDriverData.hear_about_us;
            this.goal = this.thisDriverData.goal;
            this.warning = this.thisDriverData.warning;
        },


        methods: {
            getHearAboutUsName(type, id) {
                if (type === 'restaurant') {
                    const r = this.restaurants.find(r => r.id === id);
                    return r ? r.name : '';
                }

                if (type === 'driver') {
                    const d = this.activeDrivers.find(d => d.id === id);
                    return d ? `${d.first_name} ${d.last_name}`.trim() : '';
                }
                return '';
            },
            updateHearAboutUs() {
                const type = this.hearAboutUsType;
                const id = this.hearAboutUsValue;
                const name = this.getHearAboutUsName(type, id);

                // save into the model
                this.hear_about_us = { type, id, name, paid: 0 };
                

                // reset dropdowns (optional)
                this.hearAboutUsType = '';
                this.hearAboutUsValue = null;

                this.$store.dispatch("updateHearAboutUsOrMarkPaid", {
                    driver_id: this.id,
                    hear_about_us: this.hear_about_us
                });
            },

            markAsPaid() {
                if (!this.hear_about_us.id) {
                    alert("Please update first before marking as paid"); 
                    return;
                }
                this.hear_about_us = { 
                    ...this.hear_about_us, 
                    paid: 1 
                };
                this.$store.dispatch("updateHearAboutUsOrMarkPaid", {
                    driver_id: this.id,
                   hear_about_us:{ ...this.hear_about_us,paid: 1,}
                });
            },
            async submitWarning() {
                if (!this.newWarning) {
                    this.$store.dispatch("setError", "Warning cannot be empty");
                    return;
                }
                try {
                    let driverId = this.thisDriverData.id;
                    const newWarning = await this.$store.dispatch("createDriverWarning", {
                        driverId,
                        comment: this.newWarning,
                    });

                    if (newWarning) {
                        this.warning.push(newWarning);
                    }
                    this.newWarning = "";
                } catch (error) {
                    console.error("Failed to add warning:", error);
                }
            },
            onChangeArea (/*values*/) {
                let areas_restaurants = _.map(this.restaurantsList, p => p.id);

                // clear selected restaurants on change area
                this.restaurant_ids = _.intersection(areas_restaurants, this.restaurant_ids);
            },
            onChangeRestaurant(/*values*/) {
                let restaurants = _.map(this.restaurantsList, p => p.id);
                this.restaurant_ids = _.intersection(restaurants, this.restaurant_ids);
            },
            cancel(){
                this.id = this.thisDriverData.id;
                this.firstName = this.thisDriverData.first_name;
                this.lastName = this.thisDriverData.last_name;
                this.email = this.thisDriverData.email;
                if (moment(this.thisDriverData.date_of_birth, "YYYY-MM-DD").isValid()) {
                    this.date_of_birth = moment(this.thisDriverData.date_of_birth, "YYYY-MM-DD").format('DD/MM/YYYY');
                }
                this.car_make = this.thisDriverData.car_make;
                this.car_model = this.thisDriverData.car_model;
                this.car_registration = this.thisDriverData.car_registration;
                if (moment(this.thisDriverData.car_insurance_renewal_date, "YYYY-MM-DD").isValid()) {
                    this.car_insurance_renewal_date = moment(this.thisDriverData.car_insurance_renewal_date, "YYYY-MM-DD").format('DD/MM/YYYY');
                }
                this.car_insurer = this.thisDriverData.car_insurer;
                this.have_experience = this.thisDriverData.have_experience;
                this.experience_description = this.thisDriverData.experience_description;
                this.address_1 = this.thisDriverData.address_1;
                this.address_2 = this.thisDriverData.address_2;
                this.emergency_contact_name = this.thisDriverData.emergency_contact_name;
                this.emergency_contact_phone = this.thisDriverData.emergency_contact_phone;
                this.bank_name_of_account_holder = this.thisDriverData.bank_name_of_account_holder;
                this.bank_sort_code = this.thisDriverData.bank_sort_code;
                this.bank_account_number = this.thisDriverData.bank_account_number;
                this.phone = this.thisDriverData.phone;
                this.city = this.thisDriverData.city;
                this.postcode = this.thisDriverData.postcode;
                this.status = this.thisDriverData.status;
                //
                this.driver_license_front_photo = this.thisDriverData.driver_license_front_photo;
                this.driver_license_back_photo = this.thisDriverData.driver_license_back_photo;
                this.identity_photo = this.thisDriverData.identity_photo;
                this.photo_src = this.thisDriverData.photo_src;
                //
                this.right_to_work_photos = this.thisDriverData.right_to_work_photos;
                this.area_ids = _.map(this.thisDriverData.area_ids, p => +p.area_id);
                this.restaurant_ids = _.map(this.thisDriverData.restaurant_ids, p => +p.restaurant_id);

                this.dialog = false;
            },
            submit () {
                this.localLoading = true;
                this.dialog = true;
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    const driver_data = {
                        id: this.id,
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        address_1: this.address_1,
                        address_2: this.address_2,
                        postcode: this.postcode,
                        city: this.city,
                        phone: this.phone,
                        date_of_birth: this.date_of_birth ? moment(this.date_of_birth, "DD/MM/YYYY").format('YYYY-MM-DD') : void 0,
                        emergency_contact_name: this.emergency_contact_name,
                        emergency_contact_phone: this.emergency_contact_phone,
                        car_make: this.car_make,
                        car_model: this.car_model,
                        car_registration: this.car_registration,
                        car_insurance_renewal_date: this.car_insurance_renewal_date ? moment(this.car_insurance_renewal_date, "DD/MM/YYYY").format('YYYY-MM-DD') : void 0,
                        car_insurer: this.car_insurer,
                        have_experience: this.have_experience,
                        experience_description: this.experience_description,
                        bank_name_of_account_holder: this.bank_name_of_account_holder,
                        bank_sort_code: this.bank_sort_code,
                        bank_account_number: this.bank_account_number,
                        area_ids: this.area_ids,
                        restaurant_ids: this.restaurant_ids,
                        right_to_work_photos: [],
                    };

                    if (this.switch_change_password) {
                        driver_data.password = this.password;
                    }

                    // -- process images
                    if (this.driver_license_front_src_photo) {
                        driver_data.driver_license_front_src_photo = this.driver_license_front_src_photo; // uploaded file
                    } else {
                        driver_data.driver_license_front_photo = this.driver_license_front_photo; // old photo
                    }

                    if (this.driver_license_back_src_photo) {
                        driver_data.driver_license_back_src_photo = this.driver_license_back_src_photo; // uploaded file
                    } else {
                        driver_data.driver_license_back_photo = this.driver_license_back_photo; // old photo
                    }

                    if (this.identity_src_photo) {
                        driver_data.identity_src_photo = this.identity_src_photo; // uploaded file
                    } else {
                        driver_data.identity_photo = this.identity_photo; // old photo
                    }

                    if (this.image_data) {
                        driver_data.image_data = this.image_data; // uploaded file
                    } else {
                        driver_data.photo_src = this.photo_src; // old photo
                    }

                    // photos
                    _.each(this.right_to_work_photos, (image) => {
                        if (image.file_src) {
                            // new image file
                            driver_data.right_to_work_photos.push({
                                // id:
                                // driver_id:
                                src_name: image.src_name,
                                file_src: image.file_src,
                            });
                        } else {
                            // old image (saved on server)
                            driver_data.right_to_work_photos.push({
                                id: image.id,
                                // driver_id: image.driver_id,
                                src_name: image.src_name,
                                file_name: image.file_name,
                            });
                        }
                    });

                    this.$store.dispatch('editDriver', driver_data).then(() => {
                        // this.dialog = false;
                        this.password = '';
                        this.switch_change_password = false;
                        this.cancel(); // refresh form data
                        this.$emit('driverUpdated', '');
                    })
                    .catch((errors) => {
                        this.response_errors = errors;
                    })
                    .finally(() => {
                        this.localLoading = false;
                    });
                }
            },
            dateOfBirthSelect: function() {
                this.$data.date_of_birth = moment(this.$data.date_of_birth_selected, 'YYYY-MM-DD').format("DD/MM/YYYY");
                this.$data.date_of_birth_picker = false; // hide calendar
            },
            getDateOfBirthText: function (date_of_birth_selected) {
                return moment(date_of_birth_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
            },
            carInsuranceRenewalDateSelect: function() {
                this.$data.car_insurance_renewal_date = moment(this.$data.car_insurance_renewal_date_selected, 'YYYY-MM-DD').format("DD/MM/YYYY");
                this.$data.car_insurance_renewal_date_picker = false; // hide calendar
            },
            getCarInsuranceRenewalDateText: function (car_insurance_renewal_date_selected) {
                return moment(car_insurance_renewal_date_selected, "YYYY-MM-DD").format('DD/MM/YYYY');
            },
            // --
            onAddDriverLicenseFrontPhoto() {
                this.$refs.driver_license_front_photo.click();
            },
            onRemoveDriverLicenseFrontPhoto() {
                this.driver_license_front_photo = void 0;
                this.driver_license_front_src_photo = void 0;
            },
            onChangDriverLicenseFrontPhoto() {
                if (
                    this.$refs.driver_license_front_photo.files.length == 0 ||
                    typeof FileReader == "undefined"
                ) {
                    return;
                }

                _.each(this.$refs.driver_license_front_photo.files, (file) => {
                    this.processFilePreview(file, (file_name, file_src) => {
                        this.driver_license_front_photo = file_src;
                        this.driver_license_front_src_photo = file_src;
                    });
                });

                this.$refs.driver_license_front_photo.value = null; // clear
            },
            // --
            onAddDriverLicenseBackPhoto() {
                this.$refs.driver_license_back_photo.click();
            },
            onRemoveDriverLicenseBackPhoto() {
                this.driver_license_back_photo = void 0;
                this.driver_license_back_src_photo = void 0;
            },
            onChangDriverLicenseBackPhoto() {
                if (
                    this.$refs.driver_license_back_photo.files.length == 0 ||
                    typeof FileReader == "undefined"
                ) {
                    return;
                }

                _.each(this.$refs.driver_license_back_photo.files, (file) => {
                    this.processFilePreview(file, (file_name, file_src) => {
                        this.driver_license_back_photo = file_src;
                        this.driver_license_back_src_photo = file_src;
                    });
                });

                this.$refs.driver_license_back_photo.value = null; // clear
            },
            // --
            onAddIdentityPhoto() {
                this.$refs.identity_photo.click();
            },
            onRemoveIdentityPhoto() {
                this.identity_photo = void 0;
                this.identity_src_photo = void 0;
            },
            onChangIdentityPhoto() {
                if (
                    this.$refs.identity_photo.files.length == 0 ||
                    typeof FileReader == "undefined"
                ) {
                    return;
                }

                _.each(this.$refs.identity_photo.files, (file) => {
                    this.processFilePreview(file, (file_name, file_src) => {
                        this.identity_photo = file_src;
                        this.identity_src_photo = file_src;
                    });
                });

                this.$refs.identity_photo.value = null; // clear
            },
            // --
            onAddPhotoSrc() {
                this.$refs.photo_src.click();
            },
            onRemovePhotoSrc() {
                this.photo_src = void 0;
                this.image_data = void 0;
            },
            onChangPhotoSrc() {
                if (
                    this.$refs.photo_src.files.length == 0 ||
                    typeof FileReader == "undefined"
                ) {
                    return;
                }

                _.each(this.$refs.photo_src.files, (file) => {
                    this.processFilePreview(file, (file_name, file_src) => {
                        this.photo_src = file_src;
                        this.image_data = file_src;
                    });
                });

                this.$refs.photo_src.value = null; // clear
            },
            // --
            onAddRightToWorkPhotos() {
                this.$refs.right_to_work_photo.click();
            },
            onRemoveRightToWorkPhoto(index) {
                this.right_to_work_photos.splice(index, 1);
            },
            onChangRightToWorkPhoto() {
                if (
                    this.$refs.right_to_work_photo.files.length == 0 ||
                    typeof FileReader == "undefined"
                ) {
                    return;
                }

                _.each(this.$refs.right_to_work_photo.files, (file) => {
                    this.processFilePreview(file, (file_name, file_src) => {
                        this.right_to_work_photos.push({
                            id: this.new_right_to_work_photos_uid_iterator--,
                            src_name: file_name,
                            file_name: file_src,
                            file_src: file_src,
                        });
                    });
                });

                this.$refs.right_to_work_photo.value = null; // clear
            },
            // --
            processFilePreview(file, cb) {
                if (!file || typeof FileReader == "undefined") {
                    return;
                }

                if (!image_regex.test(file.name.toLowerCase()) || image_supported_types.indexOf(file.type) == -1) {
                    this.$store.dispatch('setError', {
                        text: "Unsupported file type",
                        type: "error",
                        code: 402,
                    });
                    return;
                }

                let reader = new FileReader();
                reader.onload = function (e) {
                    if (
                        image_supported_types.indexOf(file.type) !== -1 ||
                        image_regex.test(file.name.toLowerCase())
                    ) {
                        let img = new Image();
                        img.src = e.target.result;
                        img.onload = function () {
                            img = CompressImage.compressImage(img, 90, 1920);//
                            cb(file.name.toLowerCase(), img.src);
                        }
                    } else {
                        cb(file.name.toLowerCase(), e.target.result);
                    }
                };

                reader.readAsDataURL(file);
            },
            getPhotoPath: function (photo) {
                if (photo && photo.indexOf("data:image/") === 0) {
                    return photo; // src data
                }

                return this.imagesBaseUrl + "/" + photo; // return this.imagesBaseUrl + "/thumb/" + photo;
            },
            getServiceAgreementPath(fileName) {
                return `${this.appConfig.app_url}/documents/service_agreements/driver/${fileName}`;
            },
            getAlcoholDeliveryCertificatePath(fileName) {
                return `${this.appConfig.app_url}/documents/alcohol_delivery_certificates/driver/${fileName}`;
            }   
        },
    }
</script>

<style scoped>

</style>
